function readCachedEmpresaCountry() {
  try {
    const raw = localStorage.getItem("empresaData");
    if (!raw) return null;
    const cached = JSON.parse(raw);
    return (
      cached?.pais ??
      cached?.country ??
      cached?.paisEmpresa ??
      cached?.codigoPais ??
      null
    );
  } catch {
    return null;
  }
}

function pickCountryValue(...values) {
  return values.find((value) => value != null && String(value).trim() !== "") ?? null;
}

export function getEmpresaCountry(userData, empresaData) {
  // Por ahora los admins son del mismo país que la empresa,
  // así que priorizamos el país del admin logueado (userData).
  return pickCountryValue(
    userData?.pais,
    userData?.country,
    userData?.paisEmpresa,
    userData?.codigoPais,
    userData?.empresa?.pais,
    userData?.empresa?.country,
    empresaData?.pais,
    empresaData?.country,
    empresaData?.paisEmpresa,
    empresaData?.codigoPais,
    readCachedEmpresaCountry()
  );
}

export function isUsCountry(pais) {
  if (pais == null) return false;

  const normalized = String(pais).trim().toUpperCase();
  const compact = normalized.replace(/\s+/g, "");

  return (
    normalized === "US" ||
    normalized === "USA" ||
    normalized === "U.S." ||
    normalized === "U.S.A." ||
    normalized === "UNITED STATES" ||
    normalized === "UNITED STATES OF AMERICA" ||
    normalized === "ESTADOS UNIDOS" ||
    compact === "EEUU" ||
    compact === "EE.UU." ||
    normalized.includes("UNITED STATES") ||
    normalized.includes("ESTADOS UNIDOS")
  );
}

export function isUsEmpresa(userData, empresaData) {
  return isUsCountry(getEmpresaCountry(userData, empresaData));
}
